module.exports = new __parcel__URL__("dev-summary-create-pull-request-popup.tpl.6a6b4b68.svg").toString();